import { TextField } from '@mui/material'
import { ChangeEvent } from 'react'
import { useTranslation } from 'react-i18next'

export type TextFieldItemProps = {
  field: string
  value: string
  label: string
  handleChange: (event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => void
  rows?: number
  required: boolean
  type?: string
  disabled?: boolean
  fullWidth?: boolean
}

export function TextFieldItem(props: TextFieldItemProps) {
  const { t } = useTranslation()
  return (
    <TextField
      id={props.field}
      key={props.field}
      label={t(props.label)}
      name={props.field}
      value={props.value}
      onChange={props.handleChange}
      type={props.type}
      multiline={(props.rows && props.rows > 0) || false}
      rows={props.rows}
      required={props.required}
      disabled={props.disabled}
      fullWidth={props.fullWidth ?? true}
      sx={{
        width: props.fullWidth === false ? 'auto' : '100%',
        minWidth: 0,
        maxWidth: '100%',
      }}
      variant="outlined"
      // InputLabelProps={{ className: styles.label }}
      // InputProps={{ className: classes.input }}
    />
  )
}
